<template>
    <div class="gallery-layout-module gallery-layout-module--tilted">
        <div class="tilted-gallery">
            <div :class="['tilted', {'mockups-in-gallery': isMobileOrTablet}]">
                <GetGalleryMediaContent
                    v-for="(galleryItem, index) in section.galleryItems"
                    :key="`gi_${index}`"
                    :index="index"
                    :gallery-item="galleryItem"
                    :gallery-layout="section.layout"
                    :image-styles="{aspectRatio: section.mediaAspectRatio, cornerRadius: section.cornerRadiusPx}"
                    :section="section"
                />

                <GetGalleryMediaContent
                    v-for="(galleryItem, index) in galleryItemsForTilted"
                    :key="`gi_copy_${section.galleryItems.length + index}`"
                    :gallery-item="galleryItem"
                    :gallery-layout="section.layout"
                    :image-styles="{aspectRatio: section.mediaAspectRatio, cornerRadius: section.cornerRadiusPx}"
                    :section="section"
                />
            </div>

            <div
                v-for="ghost in ghostGalleries"
                :key="ghost"
                :class="['gallery-ghost', ghost, 'tilted']"
            >
                <GetGalleryMediaContent
                    v-for="(galleryItem, index) in section.galleryItems"
                    :key="`ghost_${ghost}_gi_${index}`"
                    :gallery-item="galleryItem"
                    :gallery-layout="section.layout"
                    :image-styles="{aspectRatio: section.mediaAspectRatio, cornerRadius: section.cornerRadiusPx}"
                    :section="section"
                />

                <GetGalleryMediaContent
                    v-for="(galleryItem, index) in galleryItemsForTilted"
                    :key="`ghost_${ghost}_gi_copy_${section.galleryItems.length + index}`"
                    :gallery-item="galleryItem"
                    :gallery-layout="section.layout"
                    :image-styles="{aspectRatio: section.mediaAspectRatio, cornerRadius: section.cornerRadiusPx}"
                    :section="section"
                />
            </div>
        </div>
    </div>
</template>

<script>
import GetGalleryMediaContent from "@/scripts/view/portfolio/sections/_helper/GetGalleryMediaContent.vue";
import {MockupDeviceType} from "@/scripts/common/mockupStore/mockupStructure.js";

export default {
    name: "ViewGalleryTiltedLegacy",
    components: {
        GetGalleryMediaContent
    },
    props: {
        section: {
            type: Object,
            default: null
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        itemsToCopy() {
            const imagesN = this.section.galleryItems.length;
            return imagesN % 4 !== 0 ? Math.abs(4 - imagesN % 4) : 0;
        },
        ghostGalleries() {
            return ['before-one', 'before-two', 'before-three', 'after-one', 'after-two', 'after-three', 'top-one', 'top-two', 'bottom-one', 'bottom-two'];
        },
        galleryItemsForTilted() {
            const filtered = this.section.galleryItems.filter((item, index) => index < this.itemsToCopy);
            return this.section.galleryItems.length === 1 ? Array(3).fill(filtered).flat() : filtered;
        },
        isMobileOrTablet() {
            const mockupSettings = this.section.galleryItems[0]?.media?.mockupSettings;
            return mockupSettings
                && (mockupSettings.deviceType === MockupDeviceType.MOBILE || mockupSettings.deviceType === MockupDeviceType.TABLET);
        }
    }
}
</script>

<style global lang="scss">
    .ufo-sec--gallery:has(.gallery-layout-module--tilted) {
        overflow: hidden;

        .tilted-gallery {
            .gallery-item .mockup .mockup-svg-container .scrollable-container-mockup {
                overflow: hidden;
            }

            @media (min-width: 768px) {
                .gallery-item:nth-child(even) {
                    transform: translateY(-60px);
                }
            }
        }

        .gallery-ghost {
            .gallery-item .remove-layer {
                display: none;
            }
        }

        .tilted {
            .gallery-item:nth-child(even) {
                transform: translateY(-30px);
            }

            .gallery-item img {
                max-width: 100%;
                height: auto;
            }

            [class*="mockup--mobile--outline--"] {
                --borderRadius: 2.4vw;
            }

            @media (min-width: 576px) {
                [class*="mockup--mobile--outline--"] {
                    --borderRadius: 2vw;
                }
            }

            @media (min-width: 992px) {
                .gallery-item:nth-child(even) {
                    transform: translateY(-120px);
                }
            }
        }
    }
</style>

<style scoped lang="scss">
.gallery-layout-module--tilted {
    grid-column: 1 / -1;
    padding: 75px 0;
    position: relative;
}

.tilted-gallery {
    transform: rotate(-15deg);
    transform-origin: center center;
    position: relative;
}

.gallery-ghost {
    position: absolute;

    &.top-one {
        top: calc(-100% - 15px);
        left: 0;
    }

    &.top-two {
        top: calc(-220% - 15px);
        left: 0;
    }

    &.bottom-one {
        bottom: calc(-100% - 15px);
        left: 0;
    }

    &.bottom-two {
        bottom: calc(-220% - 15px);
        left: 0;
    }

    &.before-one {
        top: 0;
        left: calc(-100% - 15px);
    }

    &.before-two {
        top: calc(100% + 15px);
        left: calc(-100% - 15px);
    }

    &.before-three {
        bottom: calc(100% + 15px);
        left: calc(-100% - 15px);
    }

    &.after-one {
        top: 0;
        right: calc(-100% - 15px);
    }

    &.after-two {
        top: calc(100% + 15px);
        right: calc(-100% - 15px);
    }

    &.after-three {
        bottom: calc(100% + 15px);
        right: calc(-100% - 15px);
    }
}

.tilted {
    width: 100%;
    display: grid;
    grid-gap: 30px;
    justify-content: center;
    grid-template-columns: repeat(4, 1fr);
}
</style>
